import {FC, ReactNode} from 'react'
import {useCentral} from '../../../hooks/useCentral'
import {useLavanderia} from '../../../hooks/useLavanderia'
import {useKhipu} from '../../../hooks/useKhipu'
import {
  LavanderiaModel,
  TabCentralModel,
  TabLavanderiaModel,
  TabLimpiezaModel,
} from '../../../models'
import HeaderTitle from './Header'
import {useFormContext} from 'react-hook-form'
import {useLimpieza} from '../../../hooks/useLimpieza'
interface Props {
  children: ReactNode
  title: string
  isEdit?: boolean
}
const ContentForm: FC<Props> = ({children, title, isEdit = false}) => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const {currentTabItem: currentTanItemLav, changeCurrentTabItem: changeCurrentTabItemLav} =
    useLavanderia()
  const {
    currentTabItem: currentTabItemLimpieza,
    changeCurrentTabItem: changeCurrentTabItemLimpieza,
  } = useLimpieza()
  const {applicationId} = useKhipu()
  const {reset} = useFormContext()

  const handleBack = () => {
    let getCurrent
    if (applicationId.toLowerCase() === 'central') {
      getCurrent = currentTabItem
    } else if (applicationId.toLowerCase() === 'lavandería') {
      getCurrent = currentTanItemLav
    } else if (applicationId.toLowerCase() === 'hospitality') {
      getCurrent = currentTabItemLimpieza
    }
    let obj = getModelAplication(applicationId.toLowerCase(), getCurrent)
    reset()
    if (applicationId.toLowerCase() === 'central') {
      changeCurrentTabItem(obj as TabCentralModel)
    } else if (applicationId.toLowerCase() === 'lavanderia') {
      changeCurrentTabItemLav(obj as TabLavanderiaModel)
    } else if (applicationId.toLowerCase() === 'hospitality') {
      changeCurrentTabItemLimpieza(obj as TabLimpiezaModel)
    }
  }

  const getModelAplication = (
    type: string,
    currentTabItem: any,
  ): TabCentralModel | LavanderiaModel | TabLimpiezaModel => {
    switch (type) {
      case 'central': {
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: false,
        }
        return obj
      }

      case 'lavandería': {
        const obj: LavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
        }
        return obj
      }

      case 'hospitality': {
        const obj: TabLimpiezaModel = {
          ...currentTabItem,
          showPanel: false,
        }
        return obj
      }

      default: {
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: false,
        }
        return obj
      }
    }
  }
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle isEdit={isEdit} title={title} handleBack={handleBack} />
      {children}
    </div>
  )
}

export default ContentForm
